/* eslint-disable no-use-before-define */
import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import translate from '../translate';
import {
    LoadUsageReport,
    UsageByYearMonth,
    UsageReport,
} from '../../store/usageDataSlice';
import {
    isFinal,
    REQUEST_FAILURE,
    REQUEST_INITIAL,
    REQUEST_PENDING,
    REQUEST_SUCCESS,
    RequestStatus,
} from '../../store/network/managedRequest';
import UsageReportTable from './usage-report-table';
import Navbar from '../navigation/navbar';
import LeftSide from '../main/left-side';
import VerticalNavigation from '../navigation/vertical-navigation';
import LargeCard from '../main/large-card';
import { RootState } from '../../store';
import withParams from '../../nav/withParams';
import { PbRequest } from '../../store/pbRequest';
import { PbGenericRequest } from '../../store/pbRequestSlice';

const POSSIBLE_STATUSES = [
    REQUEST_INITIAL,
    REQUEST_PENDING,
    REQUEST_SUCCESS,
    REQUEST_FAILURE,
];

interface Texts {
    loading: string;
    error: string;
    title: string;
    months: { [key: number]: string };
}

interface Props {
    strings: Texts;
    params: {
        contract_period: string;
    };
    usageReport: PbGenericRequest;
    usageReportData: UsageReport | undefined;
    usageByYearMonth: UsageByYearMonth;
    LoadUsageReport: (contractPeriod: string) => void;
}

interface State {}

class DetailedUsageDataScreen extends React.Component<Props, State> {
    static propTypes = {
        strings: PropTypes.shape({
            loading: PropTypes.string,
            error: PropTypes.string,
            title: PropTypes.string,
            months: PropTypes.shape({}),
        }).isRequired,
        params: PropTypes.shape({
            contract_period: PropTypes.string,
        }).isRequired,
        usageReport: PropTypes.shape({
            status: PropTypes.oneOf(POSSIBLE_STATUSES),
            data: PropTypes.shape({
                contract_period: PropTypes.string,
                year: PropTypes.number,
                month: PropTypes.number,
                data: PropTypes.arrayOf(PropTypes.shape({})),
            }),
        }).isRequired,
        usageByYearMonth: PropTypes.shape({}).isRequired,
        LoadUsageReport: PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.props.LoadUsageReport(this.props.params.contract_period);
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.params.contract_period !==
            this.props.params.contract_period
        ) {
            this.props.LoadUsageReport(nextProps.params.contract_period);
        }
    }

    getMonthYear = () => {
        if (this.props.usageReportData) {
            return {
                month: this.props.usageReportData.month,
                year: this.props.usageReportData.year,
            };
        }
        const contractPeriod = Number(this.props.params.contract_period);
        const isValidContractPeriod = !Number.isNaN(contractPeriod);
        if (isValidContractPeriod) {
            const fallbackYear = Number((contractPeriod / 100).toFixed(0));
            const fallbackMonth = Number(contractPeriod) % 100;
            return { month: fallbackMonth, year: fallbackYear };
        }
        const date = new Date();
        return { month: date.getMonth() + 1, year: date.getFullYear() };
    };

    renderData = () => {
        if (!isFinal(this.props.usageReport.status)) {
            return <div>{this.props.strings.loading}</div>;
        }

        if (RequestStatus.FAILURE === this.props.usageReport.status) {
            return <div>{this.props.strings.error}</div>;
        }

        const data = this.props.usageReportData ?? { data: [] };
        const rows = data.data || [];

        return (
            <UsageReportTable
                usageData={rows}
                contractPeriod={this.props.params.contract_period}
            />
        );
    };

    render() {
        const { month, year } = this.getMonthYear();

        return (
            <Navbar nav>
                <Row>
                    <LeftSide>
                        <VerticalNavigation
                            selected="usage-data"
                            usageDataByYearMonth={this.props.usageByYearMonth}
                            usageDataSelected={this.getMonthYear()}
                        />
                    </LeftSide>
                    <Col xs={9} className={'col-middle'}>
                        <LargeCard
                            type={'card-edit'}
                            title={`${this.props.strings.title} ${this.props.strings.months[month] || ''} ${year}`}
                        >
                            {this.renderData()}
                        </LargeCard>
                    </Col>
                </Row>
            </Navbar>
        );
    }
}

export default connect(
    (store: RootState) => ({
        usageReport: store.pbRequest[PbRequest.GET_USAGE_REPORT],
        usageReportData: store.usageData.usageReport,
        usageByYearMonth: store.usageData.usageByYearMonth,
    }),
    { LoadUsageReport }
)(translate('DetailedUsageDataScreen')(withParams(DetailedUsageDataScreen)));
